import {
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_TABLE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE,
  ACTIVITIES_COMPONENT_TYPE_DRAW,
  ACTIVITIES_COMPONENT_TYPE_DISCUSSION_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_FILL_IN_BLANKS_RESPONSE,
  LanguageCodes,
  LANGUAGE_CODE_EN_AU,
} from 'global/constants';
import {
  ComponentMultipleChoice,
  ComponentResponse,
  ComponentTable,
  ComponentDraw,
  ComponentDiscussion,
  ComponentInteractiveResponseCategorise,
  ComponentInteractiveResponseSequence,
  ComponentFillInBlanks,
} from 'approot/activity-builder/components/component.constants';
import type { InteractiveLessonSectionComponentFragment } from '../../lesson-builder.graphql.generated';
import ComponentsPrintLayout from 'approot/activity-builder/components/components-print-layout';
import ResponsePrintAnswer from 'approot/activity-builder/components/response/response-print-answer';
import DrawPrintAnswers from 'approot/activity-builder/components/draw/draw-print-answers';
import MultipleChoicePrintAnswers from 'approot/activity-builder/components/multiple-choice/multiple-choice-print-answers';
import TablePrintAnswers from 'approot/activity-builder/components/table/table-print-answers';
import InteractiveResponseSequencePrintAnswers from 'approot/activity-builder/components/interactive-response/sequence/interactive-response-sequence-print-answers';
import InteractiveResponseCategorisePrintAnswers from 'approot/activity-builder/components/interactive-response/categorise/interactive-response-categorise-print-answers';
import DiscussionPrint from 'approot/activity-builder/components/discussion/discussion-print';
import FillInBlanksPrintAnswers from 'approot/activity-builder/components/fill-in-blanks/fill-in-blanks-print-answers';

type Props = {
  component: InteractiveLessonSectionComponentFragment;
  previewType: string;
  studentId?: number;
  language?: LanguageCodes;
  onRenderComplete?: () => void;
  contentVersion: string | null | undefined;
};

const ActivityAnswersPrintComponent = ({
  component,
  previewType,
  studentId,
  language,
  onRenderComplete,
  contentVersion,
}: Props) => {
  return (
    <>
      {/* Layout components */}
      <ComponentsPrintLayout
        component={component}
        isPrintPreview={false}
        contentVersion={contentVersion}
      />

      {/* Response components */}
      {component.type === ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE && (
        <ResponsePrintAnswer
          {...(component as ComponentResponse)}
          studentId={studentId}
        />
      )}

      {component.type ===
        ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE && (
        <MultipleChoicePrintAnswers
          {...(component as ComponentMultipleChoice)}
          studentId={studentId}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_TABLE && (
        <TablePrintAnswers
          {...(component as ComponentTable)}
          studentId={studentId}
        />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_DRAW &&
        onRenderComplete && (
          <DrawPrintAnswers
            previewType={previewType}
            {...(component as ComponentDraw)}
            studentId={studentId}
            onRenderComplete={onRenderComplete}
            language={language || LANGUAGE_CODE_EN_AU}
          />
        )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_DISCUSSION_RESPONSE && (
        <DiscussionPrint {...(component as ComponentDiscussion)} />
      )}

      {component.type === ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE && (
        <InteractiveResponseSequencePrintAnswers
          {...(component as ComponentInteractiveResponseSequence)}
          studentId={studentId}
        />
      )}

      {component.type ===
        ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE && (
        <InteractiveResponseCategorisePrintAnswers
          {...(component as ComponentInteractiveResponseCategorise)}
          studentId={studentId}
        />
      )}

      {component.type ===
        ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_FILL_IN_BLANKS_RESPONSE && (
        <FillInBlanksPrintAnswers
          {...(component as ComponentFillInBlanks)}
          studentId={studentId}
          onRenderComplete={onRenderComplete}
        />
      )}
    </>
  );
};

export default ActivityAnswersPrintComponent;
